// How to add a page on onboarding
// 1. Add a page component under "onboarding-page-wrapper" (order doesn't matter)
// 2. Add page name on a variable under computed called "pages" (re-order if you want)
// 3. Pray
<template>
  <div class="onboarding-template">
    <div class="onboarding-page-wrapper">
      <PersonalInfoPage
        @nextPage="nextPage"
        v-if="!skipPersonalInfoVerificationPage && currentPage == 'PersonalInfoPage'"
      />
      <VerificationPage
        :email="verificationEmail"
        :mobile="verificationMobile"
        @nextPage="nextPage"
        @previousPage="previousPage"
        @goToPath="goToPath"
        v-if="!skipPersonalInfoVerificationPage && currentPage == 'VerificationPage'"
      />
      <StatusZipNotificationPage
        @nextPage="nextPage"
        v-if="currentPage == 'StatusZipNotificationPage'"
      />
      <VCOMConsentPage @nextPage="nextPage" v-if="currentPage == 'VCOMConsentPage'" />
      <VCOMSurveyPage :url="onboardSurveyURL" @nextPage="nextPage" v-else-if="currentPage == 'VCOMSurveyPage'" />
      <OnboardConsentPage
        :aid="onboardConsentPage"
        meta="consent_agreement"
        @nextPage="nextPage"
        v-if="onboardConsentPage && currentPage == 'OnboardConsentAgreement'"
      />
      <OnboardConsentPage
        :aid="onboardAcceptance"
        meta="accept_agreement"
        @nextPage="nextPage"
        v-if="onboardAcceptance && currentPage == 'OnboardConsentPage'"
      />
      <FinishPage @goToPath="goToPath" v-else-if="currentPage == 'FinishPage'" />
    </div>
    <!-- <div class="onboarding-bottom-control">
      <Button
        v-if="hasPreviousPage"
        @click="previousPage"
        class="negative-button"
        type="text"
      >{{ negativeText }}</Button>
      <Button
        v-if="hasNextPage"
        @click="nextPage"
        :disabled="isNextDisabled"
        class="positive-button"
        type="primary"
        size="large"
      >{{ positiveText }}</Button>
    </div>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueCookie from "vue-cookie";
import VCOMConsentPage from "@/components/onboarding/VCOMConsentPage";
import VCOMSurveyPage from "@/components/onboarding/VCOMSurveyPage";
import EmailPage from "@/components/onboarding/EmailPage";
import FinishPage from "@/components/onboarding/FinishPage";
import ActivityPreviewPage from "@/components/onboarding/ActivityPreviewPage";
import WelcomePage from "@/components/onboarding/WelcomePage";
import StatusPickerPage from "@/components/onboarding/StatusPickerPage";
import PersonalInfoPage from "@/components/onboarding/PersonalInfoPage";
import VerificationPage from "@/components/onboarding/VerificationPage";
import StatusZipNotificationPage from "@/components/onboarding/StatusZipNotificationPage";
import OnboardConsentPage from "@/components/onboarding/OnboardConsentPage";

export default {
  name: "Onboarding",
  data() {
    return {
      currentPage: "PersonalInfoPage",
      skipIframeSurvey: false,
      verificationEmail: "",
      verificationMobile: ""
    };
  },
  components: {
    VCOMConsentPage,
    VCOMSurveyPage,
    PersonalInfoPage,
    VerificationPage,
    StatusZipNotificationPage,
    OnboardConsentPage,
    FinishPage
  },
  computed: {
    ...mapGetters("user", ["brandInfo"]),
    skipPersonalInfoVerificationPage() {
      return this.$route.query.hasOwnProperty("skip_user_info_verification")
        ? this.$route.query.skip_user_info_verification == "true"
          ? true
          : false
        : false;
    },
    onboardConsentPage() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.concent_page || null;
      return null;
    },
    onboardSurveyURL() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.survey_url || null;
      return null;
    },
    onboardAcceptance() {
      if (this.brandInfo.resource_id)
        return this.brandInfo.resource_id.onboarding_acceptance || null;
      return null;
    },
    routeBrandSlug() {
      return this.$route.params.brandSlug;
    },
    hasVerificationCode() {
      return VueCookie.get(Cons[0].PATHS.NAME + "VERIFICATION_SENT") !== null;
    },
    pages() {
      let pages = [];
      if (!this.skipPersonalInfoVerificationPage) {
        pages.push("PersonalInfoPage");
        pages.push("VerificationPage");
      }

      if (this.onboardAcceptance) {
        pages.push("OnboardConsentPage");
      }

      if (this.onboardConsentPage)
        pages.push("OnboardConsentAgreement")

      if (this.onboardSurveyURL)
        pages.push("VCOMSurveyPage")

      // if (this.routeBrandSlug == "vcom") {
      //   pages.push("VCOMConsentPage");
      //   if (!this.skipIframeSurvey) pages.push("VCOMSurveyPage");
      // }

      pages.push("StatusZipNotificationPage");
      pages.push("FinishPage");

      return pages;
    },
    isNextDisabled() {
      if (this.currentPage == "VCOMSurveyPage") {
        return !this.enableNextSurvey;
      } else if (this.currentPage == "EmailPage") {
        return !this.emailValid;
      } else return false;
    },
    hasNextPage() {
      let index = this.pages.indexOf(this.currentPage);
      switch (this.currentPage) {
        case "ActivityOnboardPreviewPage":
          return (
            this.enableOnboardConsent &&
            this.pages.length != 0 &&
            index < this.pages.length - 1
          );
          break;
        default:
          return this.pages.length != 0 && index < this.pages.length - 1;
          break;
      }
    },
    hasPreviousPage() {
      let index = this.pages.indexOf(this.currentPage);
      switch (this.currentPage) {
        case "VCOMConsentPage":
          return true;
          break;
        case "ActivityOnboardPreviewPage":
          return (
            this.enableOnboardConsent && this.pages.length != 0 && index > 0
          );
          break;
        default:
          return this.pages.length != 0 && index > 0;
          break;
      }
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (this.skipPersonalInfoVerificationPage) {
        if (this.onboardAcceptance) this.currentPage = "OnboardConsentPage";
        else {
          // if (this.routeBrandSlug == "vcom") {
          //   this.currentPage = "VCOMConsentPage";
          // } else {
          this.currentPage = "StatusZipNotificationPage";
          // }
        }
      } else {
        if (this.hasVerificationCode) this.currentPage = "VerificationPage";
        else this.currentPage = "PersonalInfoPage";
      }
    },
    showCompleteSurvey(event) {
      this.$Message({
        closable: true,
        icon: "help",
        message: { content: "Have you completed the survey?" },
        buttons: [
          {
            label: "No",
            type: "text",
            hideAfter: true,
            action: () => {}
          },
          {
            label: "Yes",
            type: "primary",
            hideAfter: true,
            action: event
          }
        ]
      });
    },
    nextPage(payload) {
      let index = this.pages.indexOf(this.currentPage);
      this.skipIframeSurvey = payload == "skipIframeSurvey";

      this.verificationEmail = payload
        ? payload.email
          ? payload.email
          : ""
        : "";
      this.verificationMobile = payload
        ? payload.mobile
          ? payload.mobile
          : ""
        : "";

      switch (this.currentPage) {
        case "VCOMSurveyPage":
          this.showCompleteSurvey(() => {
            this.currentPage = this.pages[index + 1];
          });
          break;
        case "OnboardConsentPage":
          if (payload) this.currentPage = this.pages[index+1]
          else this.currentPage = this.onboardConsentPage ? "OnboardConsentAgreement" : "StatusZipNotificationPage"
          break;
        case "OnboardConsentAgreement":
          this.currentPage = "StatusZipNotificationPage"
          break;
        default:
          this.currentPage = this.pages[index + 1];
          break;
      }
    },
    previousPage() {
      let index = this.pages.indexOf(this.currentPage);

      switch (this.currentPage) {
        case "VCOMConsentPage":
          this.nextPage();
          break;
        default:
          this.currentPage = this.pages[index - 1];
          break;
      }
    },
    goToPath(path) {
      this.$router.replace({ path: path });
    }
  }
};
</script>

<style lang="scss" scoped>
.onboarding-template {
  padding-top: 84px;
}
.onboarding-page-wrapper {
  // height: calc(100vh - 184px);
  height: 100%;
  overflow: auto;
  padding: 20px;
}
.onboarding-bottom-control {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.negative-button {
  margin-right: 2px;
}
</style>

<style lang="scss">
.positive-button {
  width: 100%;
  span {
    font-size: 20px;
    height: 40px;
  }
}
.onboarding-template {
  .input-wrapper {
    display: flex;
    align-items: center;
    margin-top: 12px;
    input {
      font-size: 17px;
    }
  }
}
</style>